import { Component, Input } from "@angular/core";
import { first, Observable } from "rxjs";
import { Store } from "@ngrx/store";
import * as moment from "moment";

import { RootState } from "../store/root";
import { stateBuilder } from "../store/utils";
import { ProductPickerValidity } from "../store/validity/state";
import { PersistenceService } from "../store/model/persistence.service";
import { IndexSection, IndexInstance } from "../store/product-index/state";
import { Environment } from "./environment";
import { ConsultationProcess, Protocol, Offer } from "../data/model";
import { trackIndex } from "../utils/utils";
import { getInitialCategory } from "../data/product.constants";
import { UtilsComponent } from "../components/utils.component";

@Component({
    selector: "zbd-product-picker",
    templateUrl: "product-picker.component.html",
    styleUrls: ["product-picker.component.css"],
})
export class ProductPickerComponent extends UtilsComponent {
    state$: Observable<LocalState>;
    validity$: Observable<ProductPickerValidity>;

    JSON = JSON;
    trackIndex = trackIndex;

    selectedCategoryKey: string = null;

    constructor(
        public persistence: PersistenceService,
        store: Store<RootState>,
    ) {
        super();

        this.state$ = LocalState.create(store);
        this.validity$ = store.select<ProductPickerValidity>(
            (s) => s.validity.customer,
        );

        this.register(
            this.state$.pipe(first()).subscribe((state) => {
                this.selectCategory(
                    getInitialCategory(state.cp.Application).name.key,
                );
            }),
        );
    }

    selectCategory(sectionKey: string) {
        this.selectedCategoryKey = sectionKey;
    }

    getEnvironment(state: LocalState): Environment {
        return {
            persistence: this.persistence,
            customOffer: state.customOffer,
            cp: state.cp,
            protocol: state.protocol,
        };
    }
}

class LocalState {
    index: IndexSection;
    customOffer: Offer;
    cp: ConsultationProcess;
    protocol: Protocol;

    static create(store: Store<RootState>): Observable<LocalState> {
        return stateBuilder(store, new LocalState())
            .apply("index", (s) => s.productIndex.index)
            .apply("customOffer", (s) => s.productIndex.customOffer)
            .apply("cp", (s) => s.model.ConsultationProcess)
            .apply("protocol", (s) => s.model.ConsultationProcess.Protocol)
            .state$;
    }
}
